import isEqual from 'lodash/isEqual'
import { useEffect } from 'react'

import { useInvoicingSettingsHost } from '../contexts/invoicingSettingsHostContext'
import type { InvoicingSettingsPreviewPatch } from '../types/invoicingSettingsPreviewPatch'

// The host cannot watch the form: the preview sits outside it, and switching sections unmounts it.
// The form reports the relevant unsaved values and clears them when it unmounts. Save does not read
// this channel.
export const useRegisterInvoicingSettingsPreviewPatch = (previewPatch: InvoicingSettingsPreviewPatch | undefined) => {
  const { setPreviewPatch } = useInvoicingSettingsHost()

  useEffect(() => {
    setPreviewPatch((currentPatch) => {
      const hasPreviewPatchChanged = !isEqual(currentPatch, previewPatch)

      return hasPreviewPatchChanged ? previewPatch : currentPatch
    })
  }, [previewPatch, setPreviewPatch])

  // Clear the active form's unsaved preview values only when that form unmounts.
  useEffect(() => {
    return () => {
      setPreviewPatch(undefined)
    }
  }, [setPreviewPatch])
}
